import React from "react"
import { Slider, SliderProps } from "@mui/material"


const DS2Slider: React.FC<SliderProps> = (props) => {
  return <Slider {...props} />
}

export default DS2Slider;
